
import React from "react";
import Apisetting from "../api/Apisetting";
import { authenticate, setCookie } from "../config/authsave";
import {
  Input,
  Flex,
  Image,
  Button,
  Row,
  Form,
  Divider,
} from "antd";
import { startTokenCheckInterval } from "../helpers/auth";
import { t } from "i18next";
import { LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import { sendApiTelegram_call_api_error } from "../utils";

const alertShownKey = "tokenExpiredAlertShow";

class Form_verify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Lang: false,
      err: "",
      errs: "",
      showLoading: false,
      data: {
        token: "",
      },
    };

    this.onChange = this.onChange.bind(this);
    this.onInput = this.onInput.bind(this);
    this.onFinish = this.onFinish.bind(this);
  }

  // --- ส่วนที่แก้ไข: เมื่อกรอกครบ 6 หลัก ให้ทำงานทันที ---
  onChange(text) {
    if (text?.length === 6) {
      this.setState(
        (prevState) => ({
          data: { ...prevState.data, token: text },
        }),
        () => {
          // ใช้ Callback ของ setState เพื่อให้มั่นใจว่าค่า token อัปเดตแล้ว
          // และเช็คว่าไม่ได้อยู่ในสถานะกำลังโหลด (Lang)
          if (!this.state.Lang) {
            this.onFinish();
          }
        }
      );
    }
  }

  onInput(value) {
    console.log("onInput:", value);
  }

  onFinish = () => {
    const {
      ip,
      userName,
      openNotification,
      setForm_verify,
      setForm_login,
      showLoader,
      setSpinning,
      history,
      handleLogin
    } = this.props;
    const { data } = this.state;

    // ตรวจสอบว่ามี token หรือไม่ก่อนยิง API
    if (!data.token || data.token.length < 6) return;

    this.setState({ Lang: true });
    showLoader();
    // setSpinning(true);

    const datapost = {
      IP: ip,
      token: data?.token,
      username: userName?.data?.username,
      user_device_id: userName?.data?.user_device_id,
    };


    try {
      Apisetting.Postlogin_verify(datapost)
        .then((res) => {
          if (res.data.success) {
            const tokenPayload = {
              token: res.data.token,
              userInfo: {
                id: res.data.user.id,
                username: res.data.user.username,
                name: res.data.user.name,
                role: res.data.user.role,
                roleID: res.data.user.roleID,
                Active_merchantId: res.data.user.Active_merchantId,
                created_at: res.data.user.created_at,
                admin_type: res.data.user.admin_type,
                admin_status: res.data.user.admin_status,
                merchantIds: res.data.user.merchantIds,
                updated_at: res.data.user.updated_at,
                user_device_id: res.data.user.user_device_id,
                // ไม่ต้องเก็บ password หรือข้อมูลเชิงลึกอื่นๆ
              }
            };
            const payload = {
              userToken: tokenPayload?.token,
              userData: tokenPayload?.userInfo,
              selectedID: tokenPayload?.userInfo?.Active_merchantId,
            };

            const sessionData = {
              token: res.data.token,
              loginTime: new Date().getTime(),
            };
            localStorage.setItem("selectedID", tokenPayload?.userInfo?.Active_merchantId);
            sessionStorage.setItem(alertShownKey, "false");

            this.setState({ errs: `${t(res.data.message)}` });
            authenticate(tokenPayload);
            if (res?.data?.token) {
              // --- [ส่วนที่เพิ่ม/แก้ไข: การเก็บลง Cookies] ---
              // เก็บ tokenPayload และ sessionData ลงคุกกี้ (ตัวอย่างนี้ตั้งไว้ 1 วัน)
              setCookie("userPayload", tokenPayload, 1);
              setCookie("sessionInfo", sessionData, 1);
              setCookie("token", res?.data?.token, 1);
            }

            if (typeof handleLogin === "function") {
              handleLogin(payload);
            }

            setTimeout(() => {
              this.setState({ Lang: false });
              setSpinning(false);
              openNotification("success", `${t(res.data.message)}`);
              startTokenCheckInterval();
              this.props.setLoadingInvoices(true);
              setForm_verify(false);
              setForm_login(true);
              if (history) {
                history.push("/dashboard");
                return;
              }
              window.location.assign("/dashboard");
            }, 2500);
          }
        })
        .catch((err) => {
          let errorMessage = err?.response?.data?.message || err.message || "An error occurred";
          setTimeout(() => {
            this.setState({ Lang: false, data: { ...data, token: "" } }); // ล้างค่า token เมื่อเกิด error เพื่อให้ผู้ใช้กรอกใหม่ได้ง่ายขึ้น
            openNotification("error", t(errorMessage));
            setSpinning(false);
          }, 2500);
        });
    } catch (error) {
      console.log(error);
      sendApiTelegram_call_api_error(error, "login_verify");
      setTimeout(() => {
        this.setState({ Lang: false, data: { ...data, token: "" } }); // ล้างค่า token เมื่อเกิด error เพื่อให้ผู้ใช้กรอกใหม่ได้ง่ายขึ้น
        setSpinning(false);
      }, 2500);
    }

  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  render() {
    const { form_verify, dataURL, showLoading, setForm_verify, setForm_login } = this.props;
    const { Lang, data } = this.state;

    return (
      <>
        {form_verify && (
          <div className={`card ${form_verify && "in"}`} style={{ padding: "30px" }}>
            <Divider orientation="left">
              <Button
                shape="circle"
                onClick={() => {
                  setForm_verify(false);
                  setForm_login(true);
                }}
                icon={<LeftOutlined />}
              />
            </Divider>
            <Form
              name="basic"
              onFinish={this.onFinish}
              onFinishFailed={this.onFinishFailed}
              autoComplete="off"
            >
              <p className="h3 fw-semibold mb-0 text-left">Two-factor</p>
              {dataURL && (
                <div className="text-center">
                  <Image width={200} src={dataURL} />
                </div>
              )}
              {dataURL && (
                <p className="text-muted mb-3">
                  {t("* ท่านยังไม่มีแอปฯ Google Authenticator ใช่ไหม ?")}{" "}
                  <span style={{ color: "#3399ff", cursor: "pointer" }} onClick={showLoading}>
                    <span style={{ color: "#3399ff", fontWeight: "500" }}>{t("ดาวน์โหลดเลย !!")}</span>
                  </span>
                </p>
              )}
              <span className="mb-0 d-block" level={5}>
                {t("กรอกรหัส 6 หลัก จากแอปฯ")} <br /> Google Authenticator
              </span>
              <br />
              <Form.Item className="mb-3 mt-3">
                <Flex gap="middle" align="flex-start" vertical style={{ maxWidth: 600 }}>
                  <Input.OTP
                    length={6}
                    autoFocus
                    size="large"
                    disabled={Lang} // ปิดการพิมพ์ขณะกำลังตรวจสอบ
                    formatter={(str) => str.toUpperCase()}
                    onChange={this.onChange}
                    style={{ width: "100%", fontWeight: "bold" }}
                    value={data?.token}
                  />
                </Flex>
              </Form.Item>

              {/* ปุ่ม Verify สามารถซ่อนไว้ หรือเอาไว้เป็นทางเลือกได้ แต่ในที่นี้จะคงไว้และให้แสดงสถานะ Loading */}
              <Row className="mt-3">
                {Lang ? <><LoadingOutlined style={{ marginRight: 5 }} /> {" "} {t("Checking...")}</> : null}
              </Row>
            </Form>
          </div>
        )}
      </>
    );
  }
}

export default Form_verify;